import type { Offer } from '@libs/common-types';

export function formatOfferDate(dateStr: string): string {
    // Parse the string into a Date object
    const date = new Date(dateStr);

    // Extract month, day, and year
    const month = date.getMonth() + 1; // getMonth() returns months from 0-11
    const day = date.getDate();
    const year = date.getFullYear();

    // Return the formatted string
    return `${month}/${day}/${year}`;
}

export function sortByDisplayRank() {
    return (a: Offer, b: Offer): number => {
        if (a.displayRank === b.displayRank) {
            /**
             * If two offers have the same displayRank,
             * sort them alphabetically in the UI
             */

            if (a.shortDescription < b.shortDescription) {
                return -1;
            }

            if (a.shortDescription > b.shortDescription) {
                return 1;
            }

            return 0;
        }

        if (a.displayRank === null) {
            return 1;
        }

        if (b.displayRank === null) {
            return -1;
        }

        return a.displayRank - b.displayRank;
    };
}

export function sortByCardSize() {
    return (a: Offer, b: Offer): number => {
        if (a.cardSize === b.cardSize) {
            return 0;
        }

        if (a.cardSize === '') {
            return 1;
        }

        if (b.cardSize === '') {
            return -1;
        }

        if (a.cardSize === 'Small') {
            return 1;
        }

        return -1;
    };
}

export function filterOffersByType({ offers, type }: { offers?: Offer[]; type?: string }): Offer[] {
    let offersMap = offers
        ?.map(offer => ({
            ...offer,
            expiration: {
                title: formatOfferDate(offer.availabilityEnd),
                description: 'See details',
            },
        }))
        .sort(sortByDisplayRank())
        .sort(sortByCardSize());

    if (type) {
        offersMap = offersMap?.filter(offer => offer.offerType === type);
        if (type === 'Featured Offer') {
            return offersMap?.sort(sortByDisplayRank()) || [];
        }
    }

    return offersMap || [];
}
